let apiDomain = '';

switch (window.location.hostname) {
  case 'localhost':
    apiDomain = 'http://npin9.cdc.lndo.site';
    break;
  default:
    apiDomain = window.location.protocol + '//' + window.location.hostname;
    break;
}

export const config = {
  API_DOMAIN: apiDomain.trim('/'),
  BASE_NAME: '/organization/submit'
};
